import {BeneficiaryPolicy} from 'Beneficiaries/models/BeneficiaryPolicy';
import {AsyncPage, Empty} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';

export enum BeneficiariesActionTypes {
  FETCH_BENEFICIARIES = 'beneficiaries/FETCH_BENEFICIARIES',
  CHANGE_BENEFICIARIES = 'beneficiaries/CHANGE_BENEFICIARIES',
  CHANGE_BENEFICIARIES_FILTER = 'beneficiaries/CHANGE_BENEFICIARIES_FILTER',
  DELETE_BENEIFICIARY = 'beneficiaries/DELETE_BENEIFICIARY',
}

export const EmptyBeneficiariesFilter: BeneficiariesFilter = {
  policyNumber: '',
  policyCompany: '',
  policyType: '',
  caseNumber: '',
  planCode: '',
};

export type BeneficiariesFilter = {
  policyNumber: string;
  policyCompany: string;
  policyType: string;
  caseNumber: string;
  planCode: string;
};

export const fetchBeneficiaries = (pageOption?: Page<BeneficiaryPolicy>, filter?: BeneficiariesFilter) => {
  return createAction(BeneficiariesActionTypes.FETCH_BENEFICIARIES, {
    filter,
    pageOption,
  });
};
export const changeBeneficiariesFilter = (beneficiariesFilter: BeneficiariesFilter) =>
  createAction(BeneficiariesActionTypes.CHANGE_BENEFICIARIES_FILTER, beneficiariesFilter);
export const changeBeneficiaries = (beneficiaries: AsyncPage<Page<BeneficiaryPolicy>>) =>
  createAction(BeneficiariesActionTypes.CHANGE_BENEFICIARIES, beneficiaries);
export const deleteBeneficiary = (beneficiaryId: string) =>
  createAction(BeneficiariesActionTypes.DELETE_BENEIFICIARY, {beneficiaryId});

type BeneficiariesActions = ReturnType<typeof changeBeneficiariesFilter> | ReturnType<typeof changeBeneficiaries>;

type BeneficiariesState = {
  beneficiaries: AsyncPage<Page<BeneficiaryPolicy>>;
  beneficiariesFilter: BeneficiariesFilter;
};

export const DEFAULT_STATE = {
  beneficiaries: new Empty(),
  beneficiariesFilter: EmptyBeneficiariesFilter,
};

export default (state: BeneficiariesState = DEFAULT_STATE, action: BeneficiariesActions): BeneficiariesState => {
  switch (action.type) {
    case BeneficiariesActionTypes.CHANGE_BENEFICIARIES_FILTER:
      return {
        ...state,
        beneficiariesFilter: action.payload,
      };
    case BeneficiariesActionTypes.CHANGE_BENEFICIARIES:
      return {
        ...state,
        beneficiaries: action.payload,
      };
    default:
      return state;
  }
};
